import React, { ReactNode } from "react"
import { Stack } from "@mui/material"

interface ToolbarProps {
  children: ReactNode
}

export default function Toolbar({ children }: ToolbarProps) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1.5}
      sx={{
        w: 1,
        p: 1.5,
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        scrollBehavior: "smooth",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": { height: 3 },
      }}
    >
      {children}
    </Stack>
  )
}
